import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view" style={{ width: "100%", margin: "auto" }}>
      <Card.Body>
        <blockquote className="blockquote mb-0">
           <p style={{ textAlign: "initial" }}>
            (السلام عليكم)! Everyone, I am{" "}
            <span className="purple">Hafiz Muhammad Hamza</span> from{" "}
            <span className="purple">Karachi, Pakistan</span>.
            <br />
            <br />
            I am a Computer Science student, currently pursuing my{" "}
            <span className="purple">BSCS at Federal Urdu University of Arts, Science & Technology</span> (Batch 2026).
            I have also completed certifications in Web and App Development from SMIT.
            <br />
            <br />
            Additionally, I am deeply passionate about{" "}
            <span className="purple">Machine Learning</span>.
            <br />
            <br />
            <b>Some of my hobbies include:</b>
          </p>
          <ul
            style={{
              paddingLeft: "10px",
              rowGap: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <li className="about-activity">
              <span className="purple">
                <ImPointRight />
              </span>
              &nbsp; My first hobby is reciting the Quran; I truly enjoy it.
            </li>
            <li className="about-activity">
              <span className="purple">
                <ImPointRight />
              </span>
              &nbsp; I enjoy solving math equations.
            </li>
            <li className="about-activity">
              <span className="purple">
                <ImPointRight />
              </span>
              &nbsp; Recently, I have developed an interest in working out.
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card >
  );
}

export default AboutCard;
